var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{staticClass:"ag-logo",attrs:{"src":"https://www.zrss.si/zrss/wp-content/themes/zrsskofein/images/zrss_zgoraj.png","border":"0","alt":"logotip"}})}
var staticRenderFns = []

export { render, staticRenderFns }